const STATUS_CANCELADA = 7;
const STATUS_VENCIDA = 12;
const PERFIS_QUE_ENDOSSAM_APOLICE_VENCIDA = [1, 4];

function paraNumero(valor) {
  const numero = parseInt(valor, 10);
  return Number.isNaN(numero) ? null : numero;
}

export default {
  STATUS_CANCELADA,
  STATUS_VENCIDA,

  /**
   * Regras das stories 35564 (analista endossa apolice vencida) e 35776
   * (corretor apenas visualiza os endossos de apolice vencida).
   */
  bloqueiaNovoEndosso(idPropostaStatus, idPerfilUsuario) {
    const status = paraNumero(idPropostaStatus);

    if (status === STATUS_CANCELADA) {
      return true;
    }
    if (status !== STATUS_VENCIDA) {
      return false;
    }
    return !PERFIS_QUE_ENDOSSAM_APOLICE_VENCIDA.includes(
      paraNumero(idPerfilUsuario)
    );
  }
};



// WEBPACK FOOTER //
// ./src/helpers/endosso-apolice.js